import { Component, OnInit } from '@angular/core';

// Service
import { ApiService } from '../../shared/service/api.service';

@Component({
  selector: 'app-corporate',
  templateUrl: './corporate.component.html',
  styles: [
  ]
})
export class CorporateComponent implements OnInit {

  dataBanner;

  constructor(private apiService: ApiService) {}

  ngOnInit(): void {
    this.apiService.getDataApi('getSubHeaderByLink/corporate-governance').subscribe(response => {
      this.dataBanner = response.data;
    });
  }

}
